import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import { motion } from "framer-motion";
import axios from "axios";
import { useUser } from "../config/userProvider";
import { apiurl } from "../config/config";
import { TbCalendarDue } from "react-icons/tb";
import { getCookie } from "../config/webStorage.js";
import {
  BiBookOpen,
  BiGift,
  BiRocket,
  BiSearchAlt2,
  BiUser,
  BiUserCheck,
  BiUserVoice,
  BiUserX,
} from "react-icons/bi";
import { CgCalendarDue } from "react-icons/cg";
import { FaUsers, FaCheckCircle, FaTimesCircle, FaClock } from "react-icons/fa";
import { VscCommentUnresolved } from "react-icons/vsc";
import {
  MdAssignmentLate,
  MdOutlinePendingActions,
  MdPauseCircleOutline,
} from "react-icons/md";
import { Bar, Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import styles from "../styles/dashboardCard.module.css";
import SearchModal from "../components/searchPopup";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { FaE, FaFileExcel } from "react-icons/fa6";
import { io } from "socket.io-client";
// import GetLocalIP from "../config/peerConnectionRTC";
import useLocalIP from "../config/peerConnectionRTC.js";
import { subscribeUser } from "../subscribe.js";


const socket = io(apiurl);

const todayStats = [
  {
    key: "selected",
    title: "Selected Applications",
    icon: <BiUser />,
    color: "from-green-500 to-green-700",
    link: "/selected-applications",
    permission: "application",
  },
  {
    key: "rejected",
    title: "Rejected Applications",
    icon: <CgCalendarDue />,
    color: "from-red-500 to-red-700",
    link: "/rejected-applications",
    permission: "application",
  },
  {
    key: "on-hold",
    title: "Hold Applications",
    icon: <CgCalendarDue />,
    color: "from-yellow-500 to-yellow-700",
    link: "/hold-applications",
    permission: "application",
  },
  {
    key: "offered",
    title: "Offered Applications",
    icon: <CgCalendarDue />,
    color: "from-orange-500 to-orange-700",
    link: "/offered-applications",
    permission: "application",
  },
  {
    key: "applied",
    title: "Interview Queue",
    icon: <BiUser />,
    color: "from-gray-500 to-gray-700",
    link: "/interview-queue",
    permission: "application",
  },
];

// const totalStats = [
//   {
//     key: "applied",
//     title: "Interview Queue",
//     icon: <VscCommentUnresolved />,
//     color: "bg-blue-500",
//     link: "/applications",
//     permission: "application",
//   },
//   {
//     key: "offered",
//     title: "offered",
//     icon: <VscCommentUnresolved />,
//     color: "bg-blue-500",
//     link: "/applications",
//     permission: "application",
//   },
//   {
//     key: "hired",
//     title: "hired",
//     icon: <BiUser />,
//     color: "bg-blue-500",
//     link: "/candidates",
//     permission: "candidate",
//   },
//   {
//     key: "on-hold",
//     title: "hold",
//     icon: <BiUser />,
//     color: "bg-blue-500",
//     link: "/candidates",
//     permission: "candidate",
//   },
//   {
//     key: "onboarding",
//     title: "onboarding",
//     icon: <BiUser />,
//     color: "bg-blue-500",
//     link: "/candidates",
//     permission: "candidate",
//   },
//   {
//     key: "training",
//     title: "training",
//     icon: <BiUser />,
//     color: "bg-blue-500",
//     link: "/candidates",
//     permission: "candidate",
//   },
//   {
//     key: "interviewing",
//     title: "In interview",
//     icon: <MdOutlinePendingActions />,
//     color: "bg-yellow-500",
//     link: "/hold-applications",
//     permission: "application",
//   },
//   {
//     key: "rejected",
//     title: "Rejected Applications",
//     icon: <MdAssignmentLate />,
//     color: "bg-red-500",
//     link: "/rejected-applications",
//     permission: "application",
//   },
//   {
//     key: "selected",
//     title: "Selected",
//     icon: <BiUser />,
//     color: "bg-green-500",
//     link: "/selected-applications",
//     permission: "application",
//   },
//   {
//     key: "not-joined",
//     title: "Not Joined",
//     icon: <BiUser />,
//     color: "bg-gray-500",
//     link: "/new-trainees",
//     permission: "trainee",
//   },
//   {
//     key: "screening",
//     title: "screening",
//     icon: <BiUser />,
//     color: "bg-gray-500",
//     link: "/new-trainees",
//     permission: "trainee",
//   },
// ];

const totalStats = [
  {
    key: "applied",
    title: "Interview Queue",
    icon: <VscCommentUnresolved />,
    color: "from-yellow-400 to-yellow-600",
    link: "/applications",
    permission: "application",
  },
  {
    key: "offered",
    title: "Offered Applications",
    icon: <BiGift />,
    color: "from-green-400 to-green-600",
    link: "/applications",
    permission: "application",
  },
  {
    key: "hired",
    title: "Hired Candidates",
    icon: <BiUserCheck />,
    color: "from-blue-400 to-blue-600",
    link: "/candidates",
    permission: "candidate",
  },
  {
    key: "on-hold",
    title: "On Hold",
    icon: <MdPauseCircleOutline />,
    color: "from-gray-400 to-gray-600",
    link: "/candidates",
    permission: "candidate",
  },
  {
    key: "onboarding",
    title: "Onboarding",
    icon: <BiRocket />,
    color: "from-purple-400 to-purple-600",
    link: "/candidates",
    permission: "candidate",
  },
  {
    key: "training",
    title: "In Training",
    icon: <BiBookOpen />,
    color: "from-indigo-400 to-indigo-600",
    link: "/candidates",
    permission: "candidate",
  },
  {
    key: "interviewing",
    title: "Interviewing",
    icon: <MdOutlinePendingActions />,
    color: "from-orange-400 to-orange-600",
    link: "/hold-applications",
    permission: "application",
  },
  {
    key: "rejected",
    title: "Rejected Applications",
    icon: <MdAssignmentLate />,
    color: "from-red-400 to-red-600",
    link: "/rejected-applications",
    permission: "application",
  },
  {
    key: "selected",
    title: "Selected Candidates",
    icon: <BiUserVoice />,
    color: "from-green-400 to-green-700",
    link: "/selected-applications",
    permission: "application",
  },
  {
    key: "not-joined",
    title: "Not Joined",
    icon: <BiUserX />,
    color: "from-gray-400 to-gray-700",
    link: "/new-trainees",
    permission: "trainee",
  },
  {
    key: "screening",
    title: "Under Screening",
    icon: <BiSearchAlt2 />,
    color: "from-pink-400 to-pink-600",
    link: "/new-trainees",
    permission: "trainee",
  },
];

const employeeStats = [
  "active",
  "inactive",
  "resigned",
  "terminated",
  "absconded",
];

// const DashboardCard = ({ title, count, icon, color, link }) => (
//   <motion.div
//     initial={{ opacity: 0, scale: 0.9 }}
//     animate={{ opacity: 1, scale: 1 }}
//     transition={{ duration: 0.3 }}
//     className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg border border-[#f0f0f0]"
//   >
//     <div className="flex items-center justify-between">
//       <div className={`text-3xl text-white rounded-full p-2 bg-gradient-to-r ${color}`}>{icon}</div>
//       <div className="text-3xl font-bold text-gray-800">{count}</div>
//     </div>
//     <div className="text-sm font-medium text-gray-500 mt-3">{title}</div>
//     <button
//       onClick={() => (window.location.href = link)}
//       className="mt-3 w-full bg-[#f0f0f0] text-gray-800 px-4 py-2 rounded-md hover:bg-[#e0e0e0] text-sm"
//     >
//       View Details
//     </button>
//   </motion.div>
// );
// ✅ Make sure path is correct

const DashboardCard = ({ title, count, icon, color, link }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.3 }}
    className={`group ${styles.cardContainer} bg-white shadow-md p-5 hover:shadow-xl border border-[#f0f0f0]`}
    onClick={() => (window.location.href = link)}
  >
    {/* Animated Gradient Fill Layer */}
    <div className={`${styles.cardFill} bg-gradient-to-r ${color}`} />

    {/* Card Content */}
    <div className="relative z-10">
      <div className="flex items-center justify-between">
        <div
          className={`text-3xl text-white rounded-full p-2 bg-gradient-to-r ${color}`}
        >
          {icon}
        </div>
        <div className="text-3xl font-bold text-gray-800 group-hover:text-white transition-colors duration-300">
          {count}
        </div>
      </div>

      <div className="text-sm font-medium text-gray-500 mt-3 group-hover:text-white transition-colors duration-300">
        {title}
      </div>

      <button className="mt-3 w-full bg-[#f0f0f0] text-gray-800 group-hover:bg-white group-hover:text-[#b4741f] px-4 py-2 rounded-md text-sm transition-all duration-300 relative z-10">
        View Details
      </button>
    </div>
  </motion.div>
);

const DashboardCard2 = ({ title, count, icon, color, link }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      onClick={() => (window.location.href = link)}
      className="group relative cursor-pointer p-5 rounded-2xl shadow-md border border-gray-200 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200 hover:shadow-xl transition-all duration-300"
    >
      {/* Darker Gradient BG Fill for Hover */}
      <div
        className={`absolute inset-0 z-0 opacity-0 group-hover:opacity-100 transition-all duration-500 bg-gradient-to-br ${color}`}
      />

      <div className="relative z-10">
        <div className="flex items-center justify-between mb-3">
          <div
            className={`text-3xl p-3 rounded-full text-white shadow-md ${color}`}
          >
            {icon}
          </div>
          <div className="text-4xl font-bold text-gray-800 group-hover:text-white transition-colors duration-300">
            {count}
          </div>
        </div>

        <h4 className="text-lg font-semibold text-gray-700 group-hover:text-white transition-colors duration-300">
          {title}
        </h4>

        <button className="mt-4 px-4 py-2 text-sm font-medium bg-white rounded-md text-gray-800 group-hover:bg-white group-hover:text-gray-900 transition-all duration-300">
          View Details
        </button>
      </div>
    </motion.div>
  );
};

function Dashboard() {
  const { userData } = useUser();
  const [dashboardData, setDashboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${apiurl}/api/dashboard/summary-dashboard?startDate=${startDate}&endDate=${endDate}`
        );
        if (response.data.success) {
          setDashboardData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, [startDate, endDate]);

  console.log("dashboardData", dashboardData);

  const statusChartData = {
    labels: Object.keys(dashboardData.range?.statusCounts || {}),
    datasets: [
      {
        label: "Today's Applications by Status",
        data: Object.values(dashboardData.range?.statusCounts || {}),
        backgroundColor: [
          "#c7852a",
          "#b4741f",
          "#a46315",
          "#8a5210",
          "#e0a15d",
          "#f3cc94",
        ],
      },
    ],
  };

  const employeeStatusChartData = {
    labels: Object.keys(dashboardData.total?.employeeStatusCounts || {}),
    datasets: [
      {
        label: "Employee Status",
        data: Object.values(dashboardData.total?.employeeStatusCounts || {}),
        backgroundColor: [
          "#418109",
          "#6c90fe",
          "#eff20c",
          "#ff3333",
          "#a46315",
          "#f3cc94",
        ],
      },
    ],
  };

  const statusLabels = Object.keys(dashboardData.total?.statusCounts || {});
  const statusValues = Object.values(dashboardData.total?.statusCounts || {});

  // Bar Chart Data
  const barData = {
    labels: statusLabels,
    datasets: [
      {
        label: "Applications by Status",
        data: statusValues,
        backgroundColor: [
          "#4f46e5",
          "#2563eb",
          "#16a34a",
          "#ea580c",
          "#facc15",
          "#0ea5e9",
          "#d946ef",
          "#f59e0b",
          "#ef4444",
          "#10b981",
          "#6366f1",
          "#dc2626",
          "#C4B5FD",
          "#F472B6",
        ],
        borderRadius: 6,
      },
    ],
  };

  // Bar Chart Options
  const barOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.y} applications`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 50,
        },
      },
    },
  };

  // Doughnut Chart Data
  const doughnutData = {
    labels: statusLabels,
    datasets: [
      {
        data: statusValues,
        backgroundColor: [
          "#4f46e5",
          "#2563eb",
          "#16a34a",
          "#ea580c",
          "#facc15",
          "#0ea5e9",
          "#d946ef",
          "#f59e0b",
          "#ef4444",
          "#10b981",
          "#6366f1",
          "#dc2626",
          "#C4B5FD",
          "#F472B6",
        ],
        borderWidth: 1,
      },
    ],
  };




// Socket event listeners
socket.on("connect", () => {
  console.log("Connected to socket server");
});

socket.on("disconnect", () => {
  console.log("Disconnected from socket server");
});
  const [attendanceCount, setAttendanceCount] = useState(0);

  useEffect(() => {
    socket.on("dashboard_updated", (data) => {
      console.log("📡 Dashboard Updated:", data);
      // setAttendanceCount(data?.data?.total?.allApplications || 100);
          // Try multiple fallback paths safely
    const count =
      data?.data?.total?.allApplications ??
      data?.total?.allApplications ??
      data?.allApplications ??
      0;

    setAttendanceCount(count);

    // Update other dashboard metrics as needed
    console.log("Updated Attendance Count:", count);
    });

    // socket.on("leave_updated", (data) => {
    //   console.log("📡 Leave Updated:", data);
    // });

    return () => {
      socket.off("dashboard_updated");
      socket.off("leave_updated");
    };
  }, []);




  if (loading) {
    return (
      <Layout>
        <div className="h-full flex justify-center items-center text-xl font-semibold">
          Initializing Dashboard...
        </div>
      </Layout>
    );
  }
  

  return (
    <Layout>
      <Container overflow="overflow-scroll">


          {/* <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Dashboard</h2>
      <div className="bg-blue-50 p-4 rounded">
        <h3 className="font-semibold">Today’s Attendance:</h3>
        <p>{attendanceCount}</p>
      </div>
    </div> */}



    {/* <GetLocalIP/> */}






     {/* <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold">Employee List</h2>
            <button
              onClick={() => setOpen(true)}
              className="bg-red-600 text-white px-4 py-2 rounded-md shadow hover:bg-red-700 transition"
            >
              Delete Employee
            </button>
          </div>

<Modal
  show={open}
  onClose={() => setOpen(false)}
  title="Delete Employee?"
  footerButtons={[
    {
      label: "Cancel",
      bgColor: "bg-gray-500",
      onClick: () => setOpen(false)
    },
    {
      label: "Delete",
      bgColor: "bg-red-600",
      Icon: MdDelete,
      onClick: handleDelete
    }
  ]}
>
  <p className="text-gray-700">Are you sure you want to delete this employee?</p>
</Modal> */}


        {/* <SearchModal /> */}


{userData?.role === "recruiter" ? (
<RecruiterDashboard />
) : (

        <div className="h-full overflow-auto p-5 space-y-10 bg-[#F9F5F1]">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-[#b4741f]">
              Dashboard Overview
            </h2>
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="border border-gray-300 shadow-sm rounded-md px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="border border-gray-300 shadow-sm rounded-md px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <button
                onClick={() =>
                  (window.location.href = `/report?startDate=${startDate}&endDate=${endDate}`)
                }
                className="bg-[#b4741f] text-white px-4 py-2 rounded-md shadow hover:bg-[#915d18] transition"
              >
                Get Report
              </button>
              <Link
                to={
                  startDate || endDate
                    ? `/applications/advanced-search?startDate=${startDate}&endDate=${endDate}`
                    : `/applications/advanced-search`
                }
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition"
              >
                <FaSearch /> Advanced Search
              </Link>

              <Link
                to={
                  startDate || endDate
                    ? `/applications/sheet?startDate=${startDate}&endDate=${endDate}`
                    : `/applications/sheet`
                }
                className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition"
              >
                <FaFileExcel /> Go to Applications Sheet
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              Today's Stats
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                <DashboardCard
                  title="Applications"
                  count={dashboardData.range?.totalApplications}
                  icon={<TbCalendarDue />}
                  color="from-blue-500 to-blue-700"
                  permission="application"
                  link="/new-applications"
                />

                {todayStats.map((stat, i) => (
                  <DashboardCard
                    key={i}
                    {...stat}
                    count={dashboardData.range?.statusCounts?.[stat.key] || 0}
                  />
                ))}
              </div>
              <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae]">
                <h2 className="text-[#b4741f] font-bold">
                  Application Status Chart
                </h2>
                <Bar data={statusChartData} />
              </div>
            </div>
          </div>

          {/* <div>
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              All-Time Stats
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              <DashboardCard
                title="allApplications"
                count={dashboardData.total?.allApplications}
                icon={<TbCalendarDue />}
                color="from-blue-500 to-blue-700"
                permission="application"
                link="/new-applications"
              />
              {totalStats.map((stat, i) => (
                <DashboardCard
                  key={i}
                  {...stat}
                  count={dashboardData.total?.statusCounts?.[stat.key] || 0}
                />
              ))}
            </div>
          </div> */}


          {/* <button onClick={subscribeUser} className="bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 transition">
  Enable Notifications
</button> */}


          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
              <DashboardCard2
                title="All Applications"
                count={dashboardData.total?.allApplications}
                icon={<TbCalendarDue />}
                color="from-blue-400 to-blue-600"
                permission="application"
                link="/new-applications"
              />
              {totalStats.map((stat, i) => (
                <DashboardCard2
                  key={i}
                  {...stat}
                  count={dashboardData.total?.statusCounts?.[stat.key] || 0}
                />
              ))}
            </div>
            <div className="">
              {/* Bar Chart */}
              <div className="bg-white p-4 rounded-xl shadow border">
                <h3 className="text-lg font-bold text-[#b4741f] mb-3">
                  Applications by Status
                </h3>
                <Bar data={barData} options={barOptions} />
              </div>

              {/* Doughnut Chart */}
              <div className="bg-white p-4 rounded-xl shadow border mt-10">
                <h3 className="text-lg font-bold text-[#b4741f] mb-3">
                  Status Distribution
                </h3>
                <Doughnut data={doughnutData} />
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-gray-700 mb-4">
              Employee Status Overview
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                <DashboardCard
                  title={`Employees: All Employees`}
                  count={dashboardData.total?.allEmployees || 0}
                  icon={<BiUser />}
                  color="bg-purple-500"
                  link="/employees"
                />
                {employeeStats.map((status, i) => (
                  <DashboardCard
                    key={i}
                    title={`Employees: ${
                      status.charAt(0).toUpperCase() + status.slice(1)
                    }`}
                    count={
                      dashboardData.total?.employeeStatusCounts?.[status] || 0
                    }
                    icon={<BiUser />}
                    color="bg-purple-500"
                    link="/employees"
                  />
                ))}
              </div>
              <div className="bg-white p-4 shadow rounded-xl border border-[#d8c9ae] ">
                <h2 className="text-[#b4741f] font-bold">
                  Employee Status Chart
                </h2>
                <Doughnut data={employeeStatusChartData} />
              </div>
            </div>
          </div>
        </div>
        )}
      </Container>
    </Layout>
  );
}

export default Dashboard;









/* =====================================================
   RECRUITER DASHBOARD
===================================================== */

const RecruiterDashboard = () => {
  const [todayStats, setTodayStats] = useState({
    total: 0,
    statuses: {},
  });

  const [rangeStats, setRangeStats] = useState({
    total: 0,
    statuses: {},
  });

  const [range, setRange] = useState("30"); // default LAST 30 DAYS
  const [customDates, setCustomDates] = useState({
    startDate: "",
    endDate: "",
  });

  /* ---------------- DATE RANGE HELPER ---------------- */

  const getDateRange = (type) => {
    let startDate = new Date();
    let endDate = new Date();

    if (type === "7") {
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
    }

    if (type === "30") {
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
    }

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  };

  /* ---------------- API CALL ---------------- */

  const fetchDashboard = async (params = {}) => {
    try {
      const token = getCookie("swtoken");

      const res = await axios.get(
        `${apiurl}/api/dashboard/recruiter-dashboard`,
        {
          params,
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      setTodayStats(res.data.data.today);
      setRangeStats(res.data.data.range);
    } catch (error) {
      console.error(
        "Recruiter Dashboard Error:",
        error?.response?.data || error.message
      );
    }
  };

  /* ---------------- DEFAULT LOAD ---------------- */

  useEffect(() => {
    // Default load → TODAY + LAST 30 DAYS
    fetchDashboard(getDateRange("30"));
  }, []);

  /* ---------------- QUICK FILTER ---------------- */

  const handleQuickFilter = (type) => {
    setRange(type);
    setCustomDates({ startDate: "", endDate: "" });

    fetchDashboard(type === "today" ? {} : getDateRange(type));
  };

  /* ---------------- CUSTOM FILTER ---------------- */

  const handleCustomFilter = () => {
    if (!customDates.startDate || !customDates.endDate) return;

    setRange("custom");
    fetchDashboard(customDates);
  };

  /* ---------------- ICON MAPPER ---------------- */

  const getStatusIcon = (status) => {
    const s = status.toLowerCase();
    if (s.includes("select")) return <FaCheckCircle />;
    if (s.includes("reject")) return <FaTimesCircle />;
    if (s.includes("offer")) return <FaCheckCircle />;
    if (s.includes("progress")) return <FaClock />;
    return <FaUsers />;
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="h-full overflow-auto p-6 space-y-10 bg-[#F9F5F1]">

      {/* ================= FILTER BAR ================= */}
      <div className="flex flex-wrap items-center gap-3">
        {["7", "30"].map((r) => (
          <button
            key={r}
            onClick={() => handleQuickFilter(r)}
            className={`px-4 py-2 rounded-lg text-sm transition ${
              range === r
                ? "bg-black text-white"
                : "bg-white border hover:bg-gray-100"
            }`}
          >
            Last {r} Days
          </button>
        ))}

        <input
          type="date"
          value={customDates.startDate}
          onChange={(e) =>
            setCustomDates({ ...customDates, startDate: e.target.value })
          }
          className="border p-2 rounded-lg"
        />

        <input
          type="date"
          value={customDates.endDate}
          onChange={(e) =>
            setCustomDates({ ...customDates, endDate: e.target.value })
          }
          className="border p-2 rounded-lg"
        />

        <button
          onClick={handleCustomFilter}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          Apply
        </button>
      </div>

      {/* ================= TODAY STATS ================= */}
      <Section title="Today">
        <StatsGrid stats={todayStats} getStatusIcon={getStatusIcon} />
      </Section>

      {/* ================= RANGE STATS ================= */}
      <Section
        title={
          range === "custom"
            ? "Custom Range"
            : `Last ${range} Days`
        }
      >
        <StatsGrid stats={rangeStats} getStatusIcon={getStatusIcon} />
      </Section>
    </div>
  );
};

/* =====================================================
   REUSABLE COMPONENTS
===================================================== */

const Section = ({ title, children }) => (
  <div>
    <h2 className="text-lg font-semibold mb-4">{title}</h2>
    {children}
  </div>
);

const StatsGrid = ({ stats, getStatusIcon }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
    <StatCard
      title="Total Applications"
      value={stats.total}
      icon={<FaUsers />}
    />

    {Object.entries(stats.statuses || {}).map(
      ([status, count]) => (
        <StatCard
          key={status}
          title={status.replace(/_/g, " ").toUpperCase()}
          value={count}
          icon={getStatusIcon(status)}
        />
      )
    )}
  </div>
);

const StatCard = ({ title, value, icon }) => (
  <div className="bg-white rounded-2xl p-5 shadow-sm flex items-center gap-4 hover:shadow-md transition">
    <div className="text-2xl text-gray-700">{icon}</div>
    <div>
      <p className="text-sm text-gray-500">{title}</p>
      <h2 className="text-2xl font-semibold">{value || 0}</h2>
    </div>
  </div>
);

